export var defaultTheme = {
    color: {
        background: '#eee',
        primary: '#324ECF',
        secondary: '#ebedfa',
        danger: '#FF3D00',
        accent: '#62727A',
        success: '#4CAF50',
    },
    fontFamily: 'Poppins',
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#333333',
        },
        subHeading: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#333333',
        },
        labels: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#666666',
        },
    },
    card: {
        backgroundColor: '#FFFFFF',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111a45',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111a45',
        },
    },
};
